module.exports = __webpack_public_path__ + "static/media/38.18e769d6.jpg";